<template>
  <div class="countdown">
    <div class="head">
      <div class="train"></div>
      <div class="title">{{language == 'nor' ? 'Neste linje åpnes' : 'The next line opens'}}</div>
    </div>
    <div class="timer">
      <div class="estimated">
        <div class="header">
          <span>{{language == 'nor' ? 'År' : 'Years'}}</span>
        </div>
        <div class="time">
          {{estimatedYears}}
        </div>
      </div>
      <div class="divider">
        <div class="header"></div>
        <div class="time">:</div>
      </div>
      <div class="estimated wide">
        <div class="header">
          <span>{{language == 'nor' ? 'Dager' : 'Days'}}</span>
        </div>
        <div class="time">
          {{estimatedDays}}
        </div>
      </div>
      <div class="divider">
        <div class="header"></div>
        <div class="time">:</div>
      </div>
      <div class="estimated">
        <div class="header">
          <span>{{language == 'nor' ? 'Timer' : 'Hours'}}</span>
        </div>
        <div class="time">
          {{estimatedHours}}
        </div>
      </div>
      <div class="divider">
        <div class="header"></div>
        <div class="time">:</div>
      </div>
      <div class="estimated">
        <div class="header">
          <span>{{language == 'nor' ? 'Min' : 'Min'}}</span>
        </div>
        <div class="time">
          {{estimatedMinutes}}
        </div>
      </div>
      <div class="divider">
        <div class="header"></div>
        <div class="time">:</div>
      </div>
      <div class="estimated">
        <div class="header">
          <span>{{language == 'nor' ? 'Sek' : 'Sec'}}</span>
        </div>
        <div class="time">
          {{estimatedSeconds}}
        </div>
      </div>
    </div>
    <div class="foot">
      <div class="year_wrapper">
        <div class="year">2023</div>
      </div>
      <div class="company">{{language == 'nor' ? 'Gjøvikbanen Nord' : 'Gjøvikbanen Nord'}}</div>
    </div>
  </div>
</template>

<script>
  import {COUNTDOWN_FINAL_DATE} from "../../../cms/server/app/abstract/constants_project";

  export default {

    name: 'Countdown',

    data () {
      return {
        targetTime: this.$moment(new Date(COUNTDOWN_FINAL_DATE)),
        estimatedYears: 0,
        estimatedDays: 0,
        estimatedHours: 0,
        estimatedMinutes: 0,
        estimatedSeconds: 0,
        handler: null,
      };
    },

    computed: {
      language() {
        return this.$parent.language;
      },
    },

    async mounted () {
      this.start();
    },

    methods: {

      start() {
        setInterval(() => this.refresh(), 200);
      },

      stop() {
        if (this.handler) {
          clearInterval(this.handler);
        }
      },

      refresh() {
        let duration = this.$moment.duration(this.targetTime.diff(this.$moment(), 'seconds'), 'seconds');
        this.estimatedYears = duration.years();
        let addedYears = this.$moment().add(this.estimatedYears, 'y');
        this.estimatedDays = Math.floor((this.targetTime.unix() - addedYears.unix()) / (3600 * 24));
        this.estimatedHours = duration.hours();
        this.estimatedHours = this.estimatedHours < 10 ? '0' + this.estimatedHours : this.estimatedHours;
        this.estimatedMinutes = duration.minutes();
        this.estimatedMinutes = this.estimatedMinutes < 10 ? '0' + this.estimatedMinutes : this.estimatedMinutes;
        this.estimatedSeconds = duration.seconds();
        this.estimatedSeconds = this.estimatedSeconds < 10 ? '0' + this.estimatedSeconds : this.estimatedSeconds;
      },

    }
  }
</script>

<style lang="less">
  @scene_bg_color: #3C00F0;
  @darken_bg_color: #000B41;

  .countdown {
    position: relative;
    margin: 0 auto;
    background-color: @scene_bg_color;
    font-size: 22px;
    color: #fff;
    padding: 25px 35px;
    box-sizing: border-box;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: center;

    .head {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      width: 100%;
      .train {
        background-repeat: no-repeat;
        background-image: url(../../static/train.svg);
        width: 59px;
        height: 19px;
      }
      .title {
        padding-left: 10px;
      }
    }

    .timer {
      padding: 25px 0 20px 0;
      display: flex;
      flex-flow: row nowrap;
      line-height: 1;
      font-size: 39px;
      font-weight: 300;
      width: 100%;
      .estimated {
        .header {
          display: flex;
          flex-flow: row nowrap;
          justify-content: center;
          font-family: 'Myriad Pro', serif;
          font-weight: bold;
          font-size: 11px;
        }
        .time {
          display: flex;
          flex-flow: row nowrap;
          justify-content: center;
          line-height: 1.3;
        }
      }
      .divider {
        margin-top: 15px;
        padding: 0 10px;
      }
    }

    .foot {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      width: 100%;
      .year_wrapper {
        padding: 5px 5px 0px 5px;
        box-sizing: border-box;
        background-color: @darken_bg_color;
        line-height: 1;
        margin-top: -1px;
      }
      .year {
        font-weight: bold;
        color: black;
        background: linear-gradient(90deg, #3C00F0 -5%, #00AAFF 95%);
        -webkit-text-fill-color: transparent;
        -webkit-background-clip: text;
      }
      .company {
        padding-left: 10px;
      }
    }

    @media screen and (min-width: 500px) {
      justify-content: center;
      .head, .timer, .foot {
        width: auto;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Countdown.vue